<template>
  <div>
    <!-- Bahagian header disembunyikan -->
    <!-- <div class="header pb-8 pt-4 pt-lg-5 d-flex align-items-center profile-header" style="min-height: 100px;">
      <b-container fluid>
        <span class="mask bg-gradient-darkblue opacity-8"></span>
      </b-container>
    </div> -->

    <!-- Spacer untuk beri ruang atas -->
    <div style="height: 60px;"></div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <edit-profile-form></edit-profile-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import EditProfileForm from './UserProfile/EditProfileForm.vue';

export default {
  components: {
    EditProfileForm,
  },
  created() {
    this.checkvalidaccess();
  },
  methods: {
    checkvalidaccess() {
      const userData = localStorage.getItem("user");

      if (userData) {
        try {
          const parsedData = JSON.parse(userData);

          if (!("valid" in parsedData) || parsedData.valid !== true) {
            this.$router.push("/login");
          }

        } catch (error) {
          this.$router.push("/login");
        }
      } else {
        this.$router.push("/login");
      }
    },

    async checkAccessAndLoadDashboard() {
      const NEW_USER_ROLE = 1;
      try {
        const hasAccess = await this.$store.dispatch("hasPermission");

        if (!hasAccess) {
          let swalText = "Sila hubungi pentadbir sistem untuk mengakses halaman ini.";
          if (this.$store.getters.role === NEW_USER_ROLE) {
            swalText = "Sila hubungi pentadbir sistem penetapan peranan.";
          }

          this.$router.push("/login");
          return;
        }

        this.loadDashboardData();
      } catch (error) {
        // Error handling jika perlu
      }
    },
  },
};
</script>

<style>
/* Tambah CSS tambahan jika perlu */
</style>
